<template>
    <div class="bi-categories-carousel">
        <swiper ref="categoriesCarouselThumbs" :options="swiperOptionThumbs" class="carousel-thumbs">
            <swiper-slide v-for="bookInsight in bookInsights" :key="bookInsight.id">
                {{ bookInsight.genre.name }}
            </swiper-slide>
        </swiper>
        <svg
            slot="button-prev"
            class="swiper-button swiper-button-prev d-none d-lg-block"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path fill="#FFFFFF" fill-rule="evenodd" d="M21.679 11.173l-6.334-6.8c-.429-.39-1.252-.551-1.732-.1-.472.443-.458 1.304.013 1.75l4.453 4.775H3.187c-.655 0-1.187.537-1.187 1.2 0 .663.532 1.2 1.187 1.2H18.08l-4.453 4.775c-.406.41-.48 1.301-.013 1.75.468.45 1.32.306 1.732-.1l6.334-6.8c.216-.233.322-.506.321-.825-.011-.286-.127-.617-.321-.825z" />
        </svg>
        <svg
            slot="button-next"
            class="swiper-button swiper-button-next d-none d-lg-block"
            width="24"
            height="24"
            viewBox="0 0 24 24"
        >
            <path fill="#FFFFFF" fill-rule="evenodd" d="M21.679 11.173l-6.334-6.8c-.429-.39-1.252-.551-1.732-.1-.472.443-.458 1.304.013 1.75l4.453 4.775H3.187c-.655 0-1.187.537-1.187 1.2 0 .663.532 1.2 1.187 1.2H18.08l-4.453 4.775c-.406.41-.48 1.301-.013 1.75.468.45 1.32.306 1.732-.1l6.334-6.8c.216-.233.322-.506.321-.825-.011-.286-.127-.617-.321-.825z" />
        </svg>
        <swiper ref="categoriesCarousel" :options="swiperOptions" class="carousel-container">
            <template v-if="bookInsights.length">
                <swiper-slide v-for="bookInsight in bookInsights" :key="bookInsight.id">
                    <book-insight-example :book-insight="bookInsight" />
                </swiper-slide>
            </template>
        </swiper>
    </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";

export default {
    name: "BiCategoriesCarousel",
    components: {
        swiper,
        swiperSlide,
        bookInsightExample:() => import(/* webpackChunkName: "book-insight-example"*/ "./book-insight-example")
    },
    props: {
        bookInsights: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            nonfictionBaseUrl: process.env.VUE_APP_NONFICTION_BASE_API_URL,
            swiperOptionThumbs: {
                spaceBetween: 10,
                slidesPerView: 1,
                touchRatio: 0.2,
                threshold: 50,
                slideToClickedSlide: true
            },
            swiperOptions: {
                spaceBetween: 10,
                threshold: 50,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            harcodedBookInsigthIds: [64, 93, 105, 145, 40],
            categoriesCarousel: {},
            scrollInterval: null
        };
    },
    computed: {
        ...mapGetters({
            nonFictionSubscriptionDaysLeft: "UserMembership/getNonFictionSubscriptionDaysLeft"
        })
    },
    mounted() {
        this.setSwiper();
    },
    methods: {
        setSwiper() {
            this.$nextTick(() => {
                this.categoriesCarousel = this.$refs.categoriesCarousel.swiper;
                const categoriesCarouselThumbs = this.$refs.categoriesCarouselThumbs.swiper;
                this.categoriesCarousel.controller.control = categoriesCarouselThumbs;
                categoriesCarouselThumbs.controller.control = this.categoriesCarousel;

                this.categoriesCarousel.on("slideChange", () => {
                    this.$store.commit("LandingCarousel/SET_CURRENT_SLIDE_INDEX", this.categoriesCarousel.activeIndex)
                })
            });
        },
        getSwiperActiveSlide(index) {
            return this.bookInsights[index];
        }
    }
}
</script>

<style lang="scss">
.bi-categories-carousel {
    position: relative;

    .carousel-thumbs {
        .swiper-wrapper {
            margin-bottom: 50px;
            justify-content: center;
            transform: initial !important;

            @media (max-width: $md) {
                flex-wrap: wrap;
                margin-bottom: 10px;
            }

            .swiper-slide {
                flex: 0 0 auto;
                width: auto !important;
                max-width: 100%;
                color: #828282;
                text-transform: uppercase;
                font-size: 15px;
                font-weight: 600;
                margin-right: 30px;
                text-align: center;
                padding: 10px 20px;
                border-radius: 30px;
                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
                transition: color .2s ease-in, box-shadow .2s ease-in;
                cursor: pointer;

                &-active {
                    color: black;
                    background-color: white;
                    box-shadow: 0 9px 10px 0 rgba(91, 19, 254, 0.12);
                }

                @media (max-width: $md) {
                    margin-right: 0 !important;
                }
            }
        }
    }

    .swiper-button-prev,
    .swiper-button-next {
        background-image: none;
    }

    .swiper-button-prev {
        left: -60px;
        transform: rotate(180deg);
    }

    .swiper-button-next {
        right: -60px;
    }
}
</style>

